<template>
    <div class="order">
        <search :search-obj-list="searchObjList"
                @reSearch="reSearch"
                :newStrType="false"
                :searchObjType="false"
                :checkUrl="''"
                ref="search">
            <template slot="button">
                <div class="button_list">
                    <el-button type="primary"
                               class="download_btn"
                               :disabled="multipleSelection.length === 0"
                               @click="openDownloadDialog"
                               v-url-check="'user.sales.3.stock.download'">下载</el-button>
                    <el-button type="primary"
                               class="notice_btn"
                               :disabled="multipleSelection.length === 0"
                               @click="toNotice"
                               v-url-check="'user.sales.1.notice.add'">发货</el-button>
                </div>
            </template>
            <template #search="{item,pushTabTwo}">
                <div style="display: inline-block">
                    <div v-if="item.name==='物品编号'">
                        <goods-search-auto-complete :value.sync="item.value"
                                                    :goodsIdSearchObj="{param: 'goodsId', name: '物品编号'}"
                                                    :goodsNoSearchObj="{param: 'goodsNo', name: '物品编号'}"
                                                    @setTags="pushTabTwo"/>
                    </div>
                    <div v-if="item.name==='客户'">
                        <CustomerMultipleSelect :value.sync="item.value"
                                                @setTags="pushTabTwo"></CustomerMultipleSelect>
                    </div>
                    <div v-if="item.name==='组别'">
                        <group-auto-complete :value.sync="item.value"
                                             @setTags="pushTabTwo"/>
                    </div>
                    <div v-if="item.name==='负责人'">
                        <cust-user-name-auto-complete :value.sync="item.value"
                                                      @setTags="pushTabTwo"
                                                      :placeholder="'请输入负责人'"
                                                      :tagParam="'customerUserId'"
                                                      :searchUrl="'/user/user/blur?userName='"
                                                      :tagName="'负责人'"/>
                    </div>
                </div>
            </template>
        </search>
        <div class="order-table">
            <qx-table :qx-table="qxTable" @updateTable="updateTable" ref="qxTable">
                <template slot="table" slot-scope="data">
                    <el-table :data="data.table"
                              @selection-change="handleSelectionChange"
                              row-key="wids"
                              @sort-change="sortChange"
                              border fit
                              :key="tableKey"
                              ref="multipleTable">
                        <el-table-column
                            type="selection"
                            label="全选"
                            :reserve-selection="true"
                            width="60"
                            align="center"
                            header-align="center">
                        </el-table-column>
                        <el-table-column v-for="(item,index) in tableItems"
                                         :key="index"
                                         :label="item.label"
                                         :prop="item.param"
                                         :show-overflow-tooltip="item.tooltip"
                                         :width="item.width"
                                         :sortable="item.sortable"
                                         :fixed="item.fixed"
                                         header-align="center">
                            <template slot-scope="scope">
                                <template v-if="item.param === 'quantity'">
                                    <span>{{ scope.row.quantity}}</span>
                                    <span>({{ scope.row.rollNum}})</span>
                                </template>
                                <template v-else-if="item.param === 'goodsNo'">
                                    <div>{{ scope.row.goodsNo }}</div>
                                    <div v-if="scope.row.custGoodsNo">{{ scope.row.custGoodsNo }}</div>
                                </template>
                                <template v-else-if="item.param === 'isOverdue'">
                                    <span style="color: red;" v-if="scope.row.idd > 0">是</span>
                                    <span v-else>否</span>
                                </template>
                                <template v-else-if="item.param === 'orderNo'">
                                    <div class="orderNo" @click="detailSaleOrder(scope.row)">{{ scope.row.orderNo}}</div>
                                    <div>{{ scope.row.custOrderNo}}</div>
                                </template>
                                <template v-else>
                                    <span>{{ scope.row[item.param] }}</span>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </qx-table>
        </div>
        <el-dialog
            title="下载"
            :visible.sync="downloadDialogVisible"
            width="30%"
            center>
            <el-form>
                <el-form-item label="下载数据" label-width="120px">
                    <el-select v-model="downloadType" placeholder="请选择">
                        <el-option
                            v-for="item in downloadTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="download_dialog_footer">
                <el-button class="download_dialog_btn" @click="closeDownloadDialog">取 消</el-button>
                <el-button class="download_dialog_btn" type="primary" @click="submitDownload">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QxTable from '../../mixins/order/common/QxTable';
    import moment from 'moment';
    import calculate from '../../plugins/calculate';

    export default {
        name: 'OrderStock',
        mixins: [QxTable],
        data() {
            return {
                searchObjList: [{
                    name: '订单编号',
                    param: 'orderNo',
                    isShow: true,
                    type: 'input',
                }, {
                    name: '物品编号',
                    param: 'goodsNo',
                    isShow: true,
                    searchType: 'slot',
                    type: 'input',
                }, {
                    name: '订单类型',
                    param: 'orderType',
                    isShow: true,
                    type: 'select',
                    selectList: [{
                        value: '大货',
                        label: '大货',
                    }, {
                        value: '试样',
                        label: '试样',
                    }]
                }],
                tableItems: [{
                    label: '订单编号',
                    param: 'orderNo',
                    sortable: false,
                }, {
                    label: '物品编号',
                    param: 'goodsNo',
                    sortable: true,
                    width: '260px'
                }, {
                    label: '米数（卷数）',
                    param: 'quantity',
                    sortable: 'custom',
                    width: '200px'
                }, {
                    label: '入库时间',
                    param: 'allocateTime',
                    sortable: true,
                    width: '200px'
                }, {
                    label: '是否逾期',
                    param: 'isOverdue',
                    width: '200px'
                }],
                qxTable: {
                    url: '/warehouse/orderStock',
                    table: [],
                    updateFlag: 0,
                    searchObj: {
                    }
                },
                tableKey: 0,
                downloadDialogVisible: false,
                downloadTypeList: [{
                    value: '码单',
                    label: '码单'
                }, {
                    value: '检验报告',
                    label: '检验报告'
                }],
                downloadType: '',
                multipleSelection: []
            };
        },
        created() {
            const goodsId = this.$route.query.goodsId || '';
            const goodsNo = this.$route.query.goodsNo || '';
            if (goodsId && goodsNo) {
                this.qxTable.searchObj = {
                    ...this.qxTable.searchObj,
                    goodsId: goodsId
                }
            }
        },
        methods: {
            defaultSearchObj() {
                return {
                    asc: false,
                    sortField: 'allocateTime',
                    splitFields: 'allocateTime,customerName,goodsNo,orderNo'
                };
            },
            reSearch(tags) {
                this.qxTable.searchObj = {
                    ...this.defaultSearchObj(),
                    asc: this.qxTable.searchObj.asc,
                    sortField: this.qxTable.searchObj.sortField
                };
                tags.map(tag => {
                    this.qxTable.searchObj[tag.param] = tag.value;
                    return true;
                });
                if (tags.length === 0) {
                    this.multipleSelection.splice(0);
                    this.$refs.multipleTable.clearSelection();
                }
                this.qxTable.updateFlag += 1;
            },
            updateTable(data) {
                this.qxTable.table = data.table.map(item => ({
                    ...item,
                    wids: `${item.ids}&${item.warehouseId}`
                }));
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            sortChange(obj) {
                if (obj.order === 'descending') {
                    this.qxTable.searchObj.asc = false;
                }
                if (obj.order === 'ascending') {
                    this.qxTable.searchObj.asc = true;
                }
                this.qxTable.searchObj.sortField = obj.prop;
                this.qxTable.updateFlag += 1;
            },
            openDownloadDialog() {
                this.downloadType = '';
                this.downloadDialogVisible = true;
            },
            closeDownloadDialog() {
                this.downloadDialogVisible = false;
            },
            async submitDownload() {
                if (!this.downloadType) {
                    this.$message.error('请选择下载数据')
                    return;
                }
                const customerName = this.multipleSelection[0].customerName;
                const today = moment().format('YYYYMMDD');
                if (this.downloadType === '检验报告') {
                    const Authorization = localStorage.getItem('token');
                    const ids = this.multipleSelection.map(item => item.ids);
                    const data = [...new Set(ids)];
                    const res = await this.qxAxios({
                        url: '/warehouse/orderStock/exportReport',
                        data,
                        method: 'post',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        const a = document.createElement('a');
                        a.download = `${customerName}-检验报告-${today}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.downloadDialogVisible = false;
                    }
                }
                if (this.downloadType === '码单') {
                    const Authorization = localStorage.getItem('token');
                    const ids = this.multipleSelection.map(item => item.ids);
                    const res = await this.qxAxios({
                        url: '/warehouse/orderStock/export',
                        data: ids,
                        method: 'post',
                        responseType: 'blob',
                        headers: { Authorization }
                    });
                    if (res.status === 200) {
                        const a = document.createElement('a');
                        a.download = `${customerName}-码单-${today}.xlsx`;
                        a.href = URL.createObjectURL(res.data);
                        a.click();
                        this.downloadDialogVisible = false;
                    }
                }
            },
            toNotice() {
                if (this.multipleSelection.every(item => item.customerId === this.multipleSelection[0].customerId)) {
                    let path = '/new-notice-order-dahuo';
                    let arr = this.multipleSelection.map(item => item.orderNo);
                    let query = {
                        orderStockList: [...new Set(arr)],
                        customerId: this.multipleSelection[0].customerId
                    };
                    this.$router.push({
                        path,
                        query
                    });
                } else {
                    this.$message.error('存在多个客户，无法批量发货')
                }
            },
            detailSaleOrder(row) {
                this.$router.push(`/detail-sale-order/${row.orderId}`);
            },

        }
    }
</script>

<style lang="scss" scoped>
    .order-table {
        height: calc(100vh - 270px);
    }
    .button_list {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 45px;
        .download_btn {
            margin: 0 10px 0 0;
            padding: 0 8px !important;
            background-color: rgba(2, 167, 240, 1);
            border-color: rgba(2, 167, 240, 1);
        }
        .transfer_btn {
            margin: 0 10px 0 0;
            padding: 0 8px !important;
            background-color: rgba(245, 154, 35, 1);
            border-color: rgba(245, 154, 35, 1);
        }
        .notice_btn {
            margin: 0 10px 0 0;
            padding: 0 8px !important;
            background-color: rgba(99, 161, 3, 1);
            border-color: rgba(99, 161, 3, 1);
        }
        .is-disabled {
            background-color: rgba(215, 215, 215, 1);
            border-color: rgba(215, 215, 215, 1);
            color: #fff;
        }
    }
    .orderNo {
        text-decoration: underline;
        cursor: pointer;
        color: rgba(2, 167, 240, 1);
    }
    .comment_btn {
        padding-left: 5px;
        color: rgba(2, 167, 240, 1);
        font-size: 18px;
    }
    .download_dialog_footer {
        display: flex;
        align-items: center;
        justify-content: center;
        .download_dialog_btn {
            width: 40%;
        }
    }
    .comment_drawer_title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        .comment_title_saleOrderNo {
            font-weight: 700;
            margin-right: 30px;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .comment_title_goodsNo {
            font-size: 16px;
            font-weight: 700;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .comment_drawer_content {
        padding: 0 20px;
        height: 100%;
        .content {
            height: calc(100vh - 300px);
            margin-bottom: 20px;
            overflow-y: auto;
            .content_item {
                display: flex;
                .content_item_left {
                    width: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .circle {
                        width: 8px;
                        height: 8px;
                        border-radius: 6px;
                        border: 2px solid rgba(2, 167, 240, 1);
                    }
                    .line {
                        width: 2px;
                        height: calc(100% - 12px);
                    }
                }
                .content_item_right {
                    width: calc(100% - 40px);
                    padding: 0 10px;
                    .comment_title {
                        min-height: 12px;
                        line-height: 12px;
                        font-size: 12px;
                        font-weight: 700;
                        .comment_title_create_time {
                            padding-right: 16px;
                        }
                    }
                    .comment_content {
                        background-color: rgba(242, 242, 242, 1);
                        padding: 6px;
                        border-radius: 4px;
                        margin: 6px 0 10px 0;
                        font-size: 13px;
                    }
                    .comment_content_current {
                        background-color: #fff;
                        border: 1px solid rgba(242, 242, 242, 1);
                        color: rgba(2, 167, 240, 1);
                        padding: 6px;
                        border-radius: 4px;
                        margin: 6px 0 10px 0;
                        box-shadow: 3px 3px 5px #aaa; /* 右下外阴影 */;
                        font-size: 13px;
                    }
                }
            }
        }
        .footer {
            .operate {
                padding: 20px 0;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .operate_btn {
                    height: 40px;
                    width: 45%;
                    margin: 0;
                }
            }
        }
    }
</style>
